<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="我的清单" name="todo_list">
        <el-row>
          <el-input v-model="todoListKeywords" placeholder="请输入关键字" clearable style="width: 300px; margin-right: 10px;"
            @clear="queryTodoList(true)"></el-input>
          <el-button @click="queryTodoList(true)" icon="el-icon-search" circle title="搜索"></el-button>
        </el-row>
        <br>
        <el-table :data="todoList" border style="width: 100%" height="650" v-loading="todoListLoading">
          <el-table-column prop="title" label="标题" width="300">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" placement="top"
                v-if="scope.row.title != null && scope.row.title.length > 48">
                <div slot="content" v-html="scope.row.title"></div>
                <span>{{ scope.row.title.substring(0, 48) + '...' }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="desc" label="简述" width="500">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" placement="top"
                v-if="scope.row.desc != null && scope.row.desc.length > 48">
                <div slot="content" v-html="scope.row.desc"></div>
                <span>{{ scope.row.desc.substring(0, 48) + '...' }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="流程类型" width="80"></el-table-column>
          <el-table-column prop="steps" label="总步数" width="70"></el-table-column>
          <el-table-column prop="has_attachment" label="含附件" width="80">
            <template v-slot="scope">
              <i :class="scope.row.has_attachment ? 'el-icon-check' : 'el-icon-close'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template v-slot="scope">
              <span v-if="scope.row.status == 1" class="red"><b>{{ scope.row.status_label }}</b></span>
              <span v-if="scope.row.status == 2" class="blue"><b>{{ scope.row.status_label }}</b></span>
              <span v-if="scope.row.status == 5" class="green"><b>{{ scope.row.status_label }}</b></span>
              <span v-if="scope.row.status == 6" class="gray"><b>{{ scope.row.status_label }}</b></span>
            </template>
          </el-table-column>
          <el-table-column prop="created_by" label="发布人"></el-table-column>
          <el-table-column prop="created_at" label="发布时间"></el-table-column>
          <el-table-column label="操作" width="240">
            <template v-slot="scope">
              <el-link class="elink-icon" icon="el-icon-circle-check" @click="viewOnly = false; editTodo(scope.row)"
                title="去确认" v-if="scope.row.status === 1"></el-link>
              <el-link class="elink-icon" icon="el-icon-finished" @click="completeTodo(scope.row)" title="标记为完成"
                v-if="scope.row.status === 2"></el-link>
              <el-link class="elink-icon" icon="el-icon-view" @click="viewOnly = true; editTodo(scope.row)" title="查看"
                v-if="scope.row.status === 5"></el-link>
              <!-- <el-link class="elink-icon" icon="el-icon-video-pause" @click="toggleHangupSchedule(scope.row)" title="挂起"
                v-if="scope.row.status === 1 || scope.row.status === 2 || scope.row.status === 4 || scope.row.status === 7"></el-link>
              <el-link class="elink-icon" icon="el-icon-video-play" @click="toggleHangupSchedule(scope.row)" title="激活"
                v-if="scope.row.status === 6"></el-link>
              <el-link class="elink-icon" icon="el-icon-switch-button" @click="closeSchedule(scope.row)" title="关闭"
                v-if="scope.row.status != 8"></el-link>
              <el-link class="elink-icon" icon="el-icon-view" @click="viewOnly = true; editSchedule(scope.row)"
                title="查看" v-if="scope.row.status === 8"></el-link> -->
              <el-link class="elink-icon" icon="el-icon-odometer" @click="timeline(scope.row, true)"
                title="时间线"></el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="todoListTotal"
            @size-change="changeTodoListSize" @current-change="currentTodoListChange" :page-sizes="[10, 20, 50, 100]"
            :page-size="todoListSize">
          </el-pagination>
        </div>
        <el-dialog :title="viewOnly === false ? '确认流程' : '查看流程'" :visible.sync="editTodoVisible"
          :close-on-click-modal="false" style="margin-top: -80px;">
          <el-descriptions class="margin-top" title="流程信息" :column="1" border>
            <el-descriptions-item>
              <template slot="label">标题</template>{{ editTodoForm.title }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">类型</template>{{ editTodoForm.type_label }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">描述</template>{{ editTodoForm.desc }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">发布人</template>{{ editTodoForm.creater }}
            </el-descriptions-item>
          </el-descriptions>
          <br>
          <el-descriptions class="margin-top" title="附件" :column="1" border>
            <el-descriptions-item v-for="(item, index) in editTodoForm.fileList" :key="index">
              <template slot="label">{{ index + 1 }}</template>
              <el-link type="primary" @click="downloadAttach(item)">{{ item.name }}</el-link>
            </el-descriptions-item>
          </el-descriptions>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editTodoForm = {}; editTodoVisible = false" v-if="viewOnly === false">取 消</el-button>
            <el-button @click="editTodoForm = {}; editTodoVisible = false" v-if="viewOnly === true">关 闭</el-button>
            <el-button type="primary" @click="confirmTodoSchedule(1)" v-if="viewOnly === false">确 认</el-button>
            <el-button type="primary" @click="confirmTodoSchedule(2)" v-if="viewOnly === false">驳 回</el-button>
          </div>
        </el-dialog>
        <el-dialog title="确认完成吗？" :visible.sync="completeTodoVisible" :close-on-click-modal="false"
          style="margin-top: -80px;">
          <el-form :model="completeTodoForm" label-width="120px" v-loading="completeTodoLoading">
            <el-form-item label="附件" prop="desc">
              <el-upload class="upload-attachment" :action="uploadApi" multiple :file-list="completeTodoForm.fileList"
                :headers="headersObj" :on-change="completeUploadSuccess">
                <el-button size="small" type="primary">选取附件</el-button>
                <div class="el-upload__tip" slot="tip"><i class="el-icon-info"></i> 非必传 如有必要</div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="completeTodoForm = {}; completeTodoVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmCompleteTodo">标记为完成</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="我发布的" name="schedule_list">
        <el-row>
          <el-input v-model="scheduleListKeywords" placeholder="请输入关键字" clearable
            style="width: 300px; margin-right: 10px;" @clear="queryScheduleList(true)"></el-input>
          <el-button @click="queryScheduleList(true)" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="createSchedule();" icon="el-icon-plus" circle title="发起流程"></el-button>
        </el-row>
        <br>
        <el-table :data="scheduleList" border style="width: 100%" height="650" v-loading="scheduleListLoading">
          <el-table-column prop="title" label="标题" width="300"></el-table-column>
          <el-table-column prop="desc" label="简述" width="500">
            <template v-slot="scope">
              <el-tooltip class="item" effect="dark" placement="top"
                v-if="scope.row.desc != null && scope.row.desc.length > 48">
                <div slot="content" v-html="scope.row.desc"></div>
                <span>{{ scope.row.desc.substring(0, 48) + '...' }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="流程类型" width="80"></el-table-column>
          <el-table-column prop="steps" label="总步数" width="70"></el-table-column>
          <el-table-column prop="has_attachment" label="含附件" width="80">
            <template v-slot="scope">
              <i :class="scope.row.has_attachment ? 'el-icon-check' : 'el-icon-close'"></i>
            </template>
          </el-table-column>
          <el-table-column prop="status_label" label="状态" width="120">
            <template v-slot="scope">
              <span v-if="scope.row.status === 1 || scope.row.status === 4 || scope.row.status === 6" class="red">
                <b>{{ scope.row.status_label }}</b>
              </span>
              <span v-if="scope.row.status === 2 || scope.row.status === 7" class="green"><b>{{ scope.row.status_label
                  }}</b></span>
              <span v-if="scope.row.status === 3 || scope.row.status === 8" class="gray"><b>{{ scope.row.status_label
                  }}</b></span>
              <span v-if="scope.row.status === 5" class="blue"><b>{{ scope.row.status_label }}</b></span>
            </template>
          </el-table-column>
          <el-table-column prop="created_by" label="发布人"></el-table-column>
          <el-table-column prop="created_at" label="发布时间"></el-table-column>
          <el-table-column label="操作" width="240">
            <template v-slot="scope">
              <el-link class="elink-icon" icon="el-icon-edit" @click="viewOnly = false; editSchedule(scope.row)"
                title="编辑" v-if="scope.row.status != 8"></el-link>
              <el-link class="elink-icon" icon="el-icon-refresh" @click="rePubSchedule(scope.row)" title="重新发布"
                v-if="scope.row.status === 4"></el-link>
              <el-link class="elink-icon" icon="el-icon-video-pause" @click="toggleHangupSchedule(scope.row)" title="挂起"
                v-if="scope.row.status === 1 || scope.row.status === 2 || scope.row.status === 4 || scope.row.status === 7"></el-link>
              <el-link class="elink-icon" icon="el-icon-video-play" @click="toggleHangupSchedule(scope.row)" title="激活"
                v-if="scope.row.status === 6"></el-link>
              <el-link class="elink-icon" icon="el-icon-switch-button" @click="closeSchedule(scope.row)" title="关闭"
                v-if="scope.row.status != 8"></el-link>
              <el-link class="elink-icon" icon="el-icon-view" @click="viewOnly = true; editSchedule(scope.row)"
                title="查看" v-if="scope.row.status === 8"></el-link>
              <el-link class="elink-icon" icon="el-icon-odometer" @click="timeline(scope.row)" title="时间线"></el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="scheduleListTotal"
            @size-change="changeScheduleListSize" @current-change="currentScheduleListChange"
            :page-sizes="[10, 20, 50, 100]" :page-size="scheduleListSize">
          </el-pagination>
        </div>
        <el-dialog title="编写流程" :visible.sync="createScheduleVisible" :close-on-click-modal="false"
          style="margin-top: -80px;">
          <el-form :model="scheduleForm" label-width="120px" :rules="scheduleRules" ref="scheduleForm"
            v-loading="createScheduleLoading" element-loading-text="正在创建流程, 请稍候">
            <el-form-item label="流程类型" prop="type">
              <el-col :span="20">
                <el-radio-group v-model="scheduleForm.type">
                  <el-radio label="1">审核</el-radio>
                  <el-radio label="2">申请</el-radio>
                  <el-radio label="3" disabled>其他</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-col :span="22">
                <el-input placeholder="请输入内容" v-model="scheduleForm.title"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="任务简述" prop="desc">
              <el-col :span="22">
                <el-input type="textarea" v-model="scheduleForm.desc"></el-input></el-col>
            </el-form-item>
            <el-form-item label="附件" prop="desc">
              <el-upload class="upload-attachment" :action="uploadApi" multiple :file-list="scheduleForm.fileList"
                :headers="headersObj" :on-change="scheduleUploadSuccess">
                <el-button size="small" type="primary">选取附件</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="设置流程">
              <el-row>
                <el-button type="primary" icon="el-icon-plus btn" size="mini" @click="addStep" circle
                  title="新增步骤"></el-button>
              </el-row>
            </el-form-item>
            <div v-for="(step, key) in steps" :key="key" :class="'step' + (key + 1)">
              <el-form-item :label="'Step ' + (key + 1)" :prop="'step' + (key + 1)">
                <el-row>
                  <el-col :span="16">
                    <el-select v-model="scheduleForm.implementers[key]" placeholder="选择待执行人" filterable clearable>
                      <el-option v-for="item in users" :key="item.id" :label="item.name_cn" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="primary" icon="el-icon-minus btn" size="mini" @click="delStep(key)" circle
                      title="删除"></el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="createScheduleVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmCreateSchedule()">发 布</el-button>
          </div>
        </el-dialog>
        <el-dialog title="编辑流程" :visible.sync="editScheduleVisible" :close-on-click-modal="false"
          style="margin-top: -80px;">
          <el-form :model="editScheduleForm" label-width="120px" :rules="editScheduleRules" ref="editScheduleForm"
            v-loading="editScheduleLoading" :element-loading-text="editScheduleLoadingText">
            <el-form-item label="流程类型" prop="type">
              <el-col :span="20">
                <el-radio-group v-model="editScheduleForm.type">
                  <el-radio label="1" :disabled="viewOnly">审核</el-radio>
                  <el-radio label="2" :disabled="viewOnly">申请</el-radio>
                  <el-radio label="3" disabled>其他</el-radio>
                </el-radio-group>
              </el-col>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-col :span="22">
                <el-input placeholder="请输入内容" v-model="editScheduleForm.title" :disabled="viewOnly"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="任务简述" prop="desc">
              <el-col :span="22">
                <el-input type="textarea" v-model="editScheduleForm.desc" :disabled="viewOnly"></el-input></el-col>
            </el-form-item>
            <el-form-item label="附件" prop="desc">
              <el-upload class="upload-attachment" :action="uploadApi" multiple :file-list="editScheduleForm.fileList"
                :headers="headersObj" :on-change="scheduleUploadSuccess">
                <el-button size="small" type="primary" v-if="viewOnly === false">选取附件</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="设置流程">
              <el-row>
                <el-button type="primary" icon="el-icon-plus btn" size="mini" @click="addEditStep" circle title="新增步骤"
                  v-if="viewOnly === false"></el-button>
              </el-row>
            </el-form-item>
            <div v-for="(step, key) in editSteps" :key="key" :class="'step' + (key + 1)">
              <el-form-item :label="'Step ' + (key + 1)" :prop="'step' + (key + 1)">
                <el-row>
                  <el-col :span="16">
                    <el-select v-model="editScheduleForm.implementers[key]" placeholder="选择待执行人" filterable clearable
                      :disabled="viewOnly">
                      <el-option v-for="item in users" :key="item.id" :label="item.name_cn" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="primary" icon="el-icon-minus btn" size="mini" @click="delEditStep(key)" circle
                      title="删除" v-if="viewOnly === false"></el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editScheduleVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmEditSchedule()" v-if="viewOnly === false">保 存</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>

    <el-drawer :title="timelineTitle" :visible.sync="timelineVisible" direction="rtl">
      <div style="padding: 10px 20px;">
        <div class="radio">
          <el-radio-group v-model="timelineReverse">
            <el-radio :label="false">正序</el-radio>
            <el-radio :label="true">倒序</el-radio>
          </el-radio-group>
        </div>
        <div class="timeline-block" v-loading="timelineLoading">
          <el-timeline :reverse="timelineReverse">
            <el-timeline-item v-for="(timeline, index) in timelineData" :key="index" :timestamp="timeline.operate_time"
              color="#409EFF">
              <div class="timeline-box">
                <div class="timeline-box-row">
                  <div class="timeline-box-label">操作人</div>
                  <div class="timeline-box-value"><b>{{ timeline.operator }}</b></div>
                </div>
                <div class="timeline-box-row">
                  <div class="timeline-box-label">类型</div>
                  <div class="timeline-box-value">{{ timeline.operate_type }}</div>
                </div>
                <div class="timeline-box-row">
                  <div class="timeline-box-label">简要</div>
                  <div class="timeline-box-value" v-html="timeline.txt"></div>
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'Schedule',
  components: {
    Nav
  },
  data() {
    return {
      activeName: 'todo_list',
      uploadApi: this.$axios.defaults.baseURL + 'files/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      colors: [
        { color: '#1989fa', percentage: 10 },
        { color: '#19bafa', percentage: 20 },
        { color: '#19eefa', percentage: 30 },
        { color: '#19fabe', percentage: 40 },
        { color: '#19fa7f', percentage: 50 },
        { color: '#25fa19', percentage: 60 },
        { color: '#97fa19', percentage: 70 },
        { color: '#8619fa', percentage: 80 },
        { color: '#fa7819', percentage: 90 },
        { color: '#fa1919', percentage: 100 }
      ],
      users: [],
      todoListKeywords: '',
      todoListLoading: false,
      todoList: [],
      todoListTotal: 0,
      todoListSize: 10,
      editTodoForm: {},
      editTodoVisible: false,
      completeTodoVisible: false,
      completeTodoLoading: false,
      completeTodoForm: {
        id: '',
        master_id: '',
        fileList: []
      },

      scheduleListKeywords: '',
      scheduleListLoading: false,
      scheduleList: [],
      scheduleListTotal: 0,
      scheduleListSize: 10,
      createScheduleVisible: false,
      createScheduleLoading: false,
      scheduleForm: {
        type: '1',
        title: '',
        desc: '',
        implementers: [],
        fileList: []
      },
      scheduleRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      steps: [{}],
      editScheduleVisible: false,
      editScheduleLoading: false,
      editScheduleLoadingText: '正在保存, 请稍候',
      editScheduleForm: {
        fileList: []
      },
      editScheduleRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'commit' }
        ]
      },
      editSteps: [],
      viewOnly: false,
      timelineReverse: false,
      timelineTitle: '',
      timelineVisible: false,
      timelineLoading: false,
      timelineData: []
    }
  },
  mounted() {
    this.queryTodoList();
    this.queryScheduleList();
    // this.intervals = setInterval(() => {
    //   if (this.activeName === 'schedule_list') {
    //     this.queryScheduleList(false, true);
    //   }
    // }, 10000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'todo_list':
          this.queryTodoList();
          break;
        case 'schedule_list':
          this.queryScheduleList();
          break;
      }
    },
    queryTodoList(search = false, iv = false) {
      if (iv === false) {
        this.todoListLoading = true;
      }
      let todoListpage = search === true ? 1 : this.todoListpage;
      this.$axios.get(`schedule/list`, {
        params: {
          keywords: this.todoListKeywords,
          size: this.todoListSize,
          page: todoListpage,
          type: 'TODO'
        }
      }).then((response) => {
        this.todoListLoading = false;
        if (response.data.code === 200) {
          this.todoList = response.data.data.data
          this.todoListTotal = response.data.data.total
        }
      });
    },
    changeTodoListSize(val) {
      this.todoListSizeListSize = val;
      this.queryTodoList();
    },
    currentTodoListChange(val) {
      this.todoListpageListPage = val;
      this.queryTodoList();
    },
    async editTodo(row) {
      this.editTodoForm = {};
      this.editTodoVisible = true;
      await this.$axios.get(`schedule/detail?id=${row.master_id}`).then((response) => {
        if (response.data.code === 200) {
          this.editTodoForm = response.data.data;
        }
      })
    },
    downloadAttach(item) {
      window.location.href = this.$axios.defaults.baseURL + 'files/download?url=' + item.response.url + '&savename=' + item.name;
    },
    confirmTodoSchedule(type) {
      let id = this.editTodoForm.id;
      if (type === 1) {
        // 确认
        this.$confirm('确认吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$axios.post(`/schedule/comfirm?id=${id}`).then((response) => {
            if (response.data.code === 200) {
              this.editTodoVisible = false;
              this.queryTodoList();
              this.$notify({
                title: '提示',
                message: '操作成功',
                type: 'success'
              })
            }
          })
        })
      } else {
        this.$prompt('请输入驳回理由', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          this.$axios.post(`/schedule/reject`, {
            id: id,
            memo: value
          }).then((response) => {
            if (response.data.code === 200) {
              this.editTodoVisible = false;
              this.queryTodoList();
              this.$notify({
                title: '提示',
                message: '操作成功',
                type: 'success'
              })
            }
          })
        })
      }
    },
    completeTodo(row) {
      this.completeTodoVisible = true;
      this.completeTodoForm.id = row.id
      this.completeTodoForm.master_id = row.master_id
    },
    completeUploadSuccess(file, fileList) {
      this.completeTodoForm.fileList = fileList;
    },
    confirmCompleteTodo() {
      this.completeTodoLoading = true;
      this.$axios.post(`/schedule/complete`, this.completeTodoForm).then((response) => {
        this.completeTodoLoading = false;
        if (response.data.code === 200) {
          this.completeTodoVisible = false;
          this.queryTodoList();
          this.$notify({
            title: '提示',
            message: '操作成功',
            type: 'success'
          })
        }
      })
    },


    queryScheduleList(search = false, iv = false) {
      if (iv === false) {
        this.scheduleListLoading = true;
      }
      let scheduleListpage = search === true ? 1 : this.scheduleListPage;
      this.$axios.get(`schedule/list`, {
        params: {
          keywords: this.scheduleListKeywords,
          size: this.scheduleListSize,
          page: scheduleListpage,
          type: 'SCHEDULE'
        }
      }).then((response) => {
        this.scheduleListLoading = false;
        if (response.data.code === 200) {
          this.scheduleList = response.data.data.data
          this.scheduleListTotal = response.data.data.total
        }
      });
    },
    changeScheduleListSize(val) {
      this.scheduleListSize = val;
      this.queryScheduleList();
    },
    currentScheduleListChange(val) {
      this.scheduleListPage = val;
      this.queryScheduleList();
    },
    async createSchedule() {
      this.createScheduleVisible = true;
      await this.$axios.get(`/basic/users/list`).then((response) => {
        if (response.data.code === 200) {
          this.users = response.data.data
        }
      })
    },
    addStep() {
      this.steps.push([]);
    },
    delStep(key) {
      if (key > 0) {
        this.steps.splice(key, 1)
      } else {
        this.$message({
          type: 'error',
          message: '第一个流程不能删除'
        });
      }
    },
    confirmCreateSchedule() {
      this.$refs.scheduleForm.validate(valid => {
        if (valid) {
          this.createScheduleLoading = true;
          this.$axios.post('/schedule/save',
            this.scheduleForm
          ).then((response) => {
            this.createScheduleLoading = false;
            if (response.data.code === 200) {
              this.queryScheduleList();
              this.createScheduleVisible = false;
            }
          }).catch(function () {
            this.createScheduleLoading = false;
          })
        }
      })
    },
    scheduleUploadSuccess(file, fileList) {
      this.scheduleForm.fileList = fileList;
    },
    async editSchedule(row) {
      this.editScheduleForm = {};
      this.editSteps = [];
      this.editScheduleVisible = true;
      this.editScheduleLoadingText = '正在加载, 请稍候'
      this.editScheduleLoading = true;
      await this.$axios.get(`/basic/users/list`).then((response) => {
        if (response.data.code === 200) {
          this.users = response.data.data
        }
      })
      await this.$axios.get(`schedule/detail?id=${row.id}`).then((response) => {
        this.editScheduleLoading = false;
        if (response.data.code === 200) {
          this.editScheduleForm = response.data.data;
          this.editSteps = response.data.data.implementers
        }
      })
    },
    addEditStep() {
      this.editSteps.push([]);
    },
    delEditStep(key) {
      if (key > 0) {
        this.editSteps.splice(key, 1)
      } else {
        this.$message({
          type: 'error',
          message: '第一个流程不能删除'
        });
      }
    },
    confirmEditSchedule() {
      this.$refs.editScheduleForm.validate(valid => {
        if (valid) {
          this.editScheduleLoading = true;
          this.$axios.post('/schedule/save',
            this.editScheduleForm
          ).then((response) => {
            this.editScheduleLoading = false;
            if (response.data.code === 200) {
              this.queryScheduleList();
              this.editScheduleVisible = false;
            }
          }).catch(function () {
            this.editScheduleLoading = false;
          })
        }
      })
    },
    toggleHangupSchedule(row) {
      let status = row.status;
      let txt = status === 6 ? '激活' : '挂起'
      this.$confirm('确定' + txt + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        this.$axios.post(`/schedule/hangup?id=${row.id}`).then((response) => {
          this.queryScheduleList();
          if (response.data.code === 200) {
            this.$notify({
              title: '提示',
              message: '操作成功',
              type: 'success'
            })
          }
        })
      })
    },
    rePubSchedule(row) {
      this.$confirm('确定发布吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        this.$axios.post(`/schedule/publish?id=${row.id}`).then((response) => {
          this.queryScheduleList();
          if (response.data.code === 200) {
            this.$notify({
              title: '提示',
              message: '操作成功',
              type: 'success'
            })
          }
        })
      })
    },
    closeSchedule(row) {
      this.$confirm('确定关闭吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        this.$axios.post(`/schedule/close?id=${row.id}`).then((response) => {
          this.queryScheduleList();
          if (response.data.code === 200) {
            this.$notify({
              title: '提示',
              message: '操作成功',
              type: 'success'
            })
          }
        })
      })
    },
    timeline(row, iv = false) {
      let id = iv === false ? row.id : row.master_id;
      this.timelineVisible = true;
      this.timelineLoading = true;
      this.timelineTitle = '流程: ' + row.title + ' 的时间线'
      this.$axios.get(`/schedule/timeline?id=${id}`).then((response) => {
        this.timelineLoading = false;
        if (response.data.code === 200) {
          this.timelineData = response.data.data;
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.intervals);
  }
}
</script>

<style scoped>
.btn:hover {
  cursor: pointer;
  color: #409EFF;
}

.blue {
  color: #409EFF;
}

.green {
  color: #67C23A
}

.orange {
  color: #E6A23C;
}

.red {
  color: #F56C6C;
}

.gray,
.grey {
  color: #909399;
}

.timeline-block {
  margin-top: 20px;
  overflow: auto;
  padding: 20px 10px 10px 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.timeline-block /deep/ .el-timeline-item__timestamp {
  border-bottom: solid 1px #E4E7ED;
  padding-bottom: 5px;
}

.timeline-box-row {
  width: 100%;
  display: flex;
  align-items: start;
  margin-bottom: 8px;

  .timeline-box-label {
    width: 60px;
    color: gray;
    min-height: 24px;
    line-height: 24px;
  }

  .timeline-box-label::after {
    content: ':';
  }

  .timeline-box-value {
    width: calc(100% - 60px);
    min-height: 24px;
    line-height: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Modules/Schedule.vue